<template>
    <BModal v-model="isOpen"
            size="md"
            centered
            hide-footer
            :title="modalTitle">
        <div class="row">
            <div class="col-12 whitespace-pre-line" v-html="item.details">
            </div>
        </div>
    </BModal>
</template>

<script>
import { mapState } from 'vuex';
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.diagram.isDetailsModalOpen;
      },
      set(val) {
        this.$store.commit('diagram/isDetailsModalOpen', val);
      },
    },
    ...mapState({
      item: (state) => state.diagram.item,
    }),
    modalTitle() {
      return this.item.sublevel
        ? `${this.item.level} (${this.item.sublevel}), ${this.item.category} - ${this.item.name}`
        : `${this.item.level}, ${this.item.category} - ${this.item.name}`;
    },
  },
  methods: {
    close() {
      this.$store.commit('diagram/isDetailsModalOpen', false);
    },
  },
};
</script>
